import { getCollectionForExport } from '../helpers/collectionHelper';

export const getModal = (state) => {
    return state.presentationState.modal;
};

export const getHomeCollection = (state) => {
    const collection = state.presentationState.collection.home;
    if (!collection || !collection.features) {
        return false;
    }
    return collection;
};

export const getTrailGroupCollection = (state) => {
    const uuid = state.presentationState.collection.activeGuid;
    if (!uuid) {
        return false;
    }
    const collection = state.presentationState.collection.group[uuid];
    if (!collection || !collection.features) {
        return false;
    }
    return collection;
};

export const getTrailCollectionByGuid = (state, uuid) => {
    if (!uuid) {
        return false;
    }
    const collection = state.presentationState.collection.trail[uuid];
    if (!collection || !collection.features) {
        return false;
    }
    return collection;
};

export const getTrailCollection = (state) => {
    const uuid = state.presentationState.collection.activeGuid;
    return getTrailCollectionByGuid(state, uuid);
};

export const getTrailCollectionForExport = (state) => {
    const uuid = state.presentationState.collection.activeGuid;
    const collection = getTrailCollectionByGuid(state, uuid);
    return getCollectionForExport(collection);
};

export const getNextMapAction = (state) => {
    const stack = [...state.presentationState.mapActionStack];
    return stack[stack.length - 1];
};
